(function () {
  function init(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches('.js-featured-collection')) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(scope.querySelectorAll('.js-featured-collection')));
    }

    sections.forEach(function (section) {
      if (section.dataset.justynaCursorReady === 'true') return;

      var area = section.querySelector('.js-featured-collection-cursor-area');
      var cursor = section.querySelector('.js-featured-collection-custom-cursor');
      if (!area || !cursor) return;

      section.dataset.justynaCursorReady = 'true';

      var cursorX = 0;
      var cursorY = 0;
      var renderX = 0;
      var renderY = 0;
      var cursorFrame = null;

      function updateCursorPosition(clientX, clientY, immediately) {
        var rect = section.getBoundingClientRect();
        cursorX = clientX - rect.left;
        cursorY = clientY - rect.top;

        if (immediately) {
          renderX = cursorX;
          renderY = cursorY;
        }

        if (!cursorFrame) animateCursor();
      }

      function animateCursor() {
        renderX += (cursorX - renderX) * 0.24;
        renderY += (cursorY - renderY) * 0.24;
        cursor.style.left = renderX.toFixed(2) + 'px';
        cursor.style.top = renderY.toFixed(2) + 'px';
        cursorFrame = window.requestAnimationFrame(animateCursor);
      }

      function stopCursorAnimation() {
        if (!cursorFrame) return;
        window.cancelAnimationFrame(cursorFrame);
        cursorFrame = null;
      }

      area.addEventListener('pointerenter', function (event) {
        if (!window.matchMedia('(pointer: fine) and (min-width: 992px)').matches) return;
        cursor.classList.add('is-visible');
        updateCursorPosition(event.clientX, event.clientY, true);
      });

      area.addEventListener('pointermove', function (event) {
        updateCursorPosition(event.clientX, event.clientY, false);
      }, { passive: true });

      area.addEventListener('pointerleave', function () {
        cursor.classList.remove('is-visible', 'is-dragging');
        stopCursorAnimation();
      });

      area.addEventListener('pointerdown', function () {
        cursor.classList.add('is-dragging');
      });

      area.addEventListener('pointerup', function () {
        cursor.classList.remove('is-dragging');
      });

      var wheelLock = false;

      function allowSingleClick() {
        var slider = area.closest('.js-featured-collection-slider');
        var swiper = slider && slider.swiper;

        if (!swiper) {
          window.setTimeout(allowSingleClick, 160);
          return;
        }

        swiper.params.preventClicks = false;
        swiper.params.preventClicksPropagation = false;
      }

      allowSingleClick();

      area.addEventListener('wheel', function (event) {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 8) return;

        var slider = area.closest('.js-featured-collection-slider');
        var swiper = slider && slider.swiper;
        if (!swiper || wheelLock) return;

        event.preventDefault();
        wheelLock = true;

        if (event.deltaX > 0) {
          swiper.slideNext();
        } else {
          swiper.slidePrev();
        }

        window.setTimeout(function () {
          wheelLock = false;
        }, 360);
      }, { passive: false });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
